import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Heart, Leaf, ShieldCheck, ChevronRight } from "lucide-react";
import { Button } from "../components/ui/button";

export default function QuemSomos() {
  const values = [
    { icon: Sparkles, title: "Inovação", desc: "Selecionamos apenas dispositivos com tecnologia comprovada e resultados reais." },
    { icon: Heart, title: "Cuidado", desc: "A tua pele e o teu bem-estar estão no centro de tudo o que fazemos." },
    { icon: Leaf, title: "Consciência", desc: "Apostamos em embalagens responsáveis e num consumo mais inteligente." },
    { icon: ShieldCheck, title: "Confiança", desc: "Garantia de 2 anos e apoio dedicado em cada compra." },
  ];

  return (
    <div>
      {/* Hero */}
      <section className="relative h-[52vh] min-h-[380px] overflow-hidden bg-secondary">
        <img
          src="https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?w=1600&q=80"
          alt="Quem somos RADIX"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/25 to-transparent" />
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-6 md:px-10 w-full">
            <div className="max-w-lg text-white">
              <span className="inline-block text-xs tracking-[0.25em] uppercase mb-4 border-b border-white/40 pb-1">
                A nossa história
              </span>
              <h1 className="font-serif text-4xl md:text-6xl leading-[1.05]">
                Beleza inteligente, ao teu alcance
              </h1>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-6 py-10">
        <nav className="text-sm text-muted-foreground mb-8 flex items-center gap-1">
          <Link to="/" className="hover:text-primary">Início</Link>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="text-foreground">Quem Somos</span>
        </nav>

        <div className="space-y-6 text-[15px] leading-relaxed text-muted-foreground">
          <p>
            A <strong className="text-foreground">RADIX</strong> nasceu de uma ideia simples:
            os melhores tratamentos de beleza não deviam estar reservados apenas às clínicas e
            aos salões. Acreditamos que toda a gente merece ter acesso a tecnologia de beleza
            profissional no conforto de casa — de forma acessível, prática e eficaz.
          </p>
          <p>
            Somos uma marca portuguesa apaixonada por <em>beauty-tech</em>. Percorremos o mundo
            à procura dos dispositivos mais inovadores — máscaras de luz LED, aparelhos de
            microcorrente, ferramentas de styling e muito mais — e selecionamos apenas aqueles
            que realmente cumprem o que prometem. Cada produto é testado e escolhido a pensar
            em ti.
          </p>
          <p>
            Mais do que vender gadgets, queremos ajudar-te a criar um ritual de autocuidado que
            te faça sentir bem todos os dias. Porque quando cuidas de ti, isso reflete-se em
            tudo o resto.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 my-12 not-prose">
          {[
            { n: "50.000+", l: "Clientes felizes" },
            { n: "4.8/5", l: "Avaliação média" },
            { n: "2 anos", l: "Garantia total" },
          ].map((s) => (
            <div key={s.l} className="text-center border border-border rounded-lg py-6 bg-card">
              <p className="font-serif text-3xl text-primary">{s.n}</p>
              <p className="text-xs text-muted-foreground mt-1">{s.l}</p>
            </div>
          ))}
        </div>

        {/* Values */}
        <h2 className="font-serif text-2xl mb-6">Os nossos valores</h2>
        <div className="grid sm:grid-cols-2 gap-5">
          {values.map((v) => (
            <div key={v.title} className="flex gap-4">
              <div className="h-11 w-11 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                <v.icon className="h-5 w-5 text-primary" />
              </div>
              <div>
                <p className="font-medium text-foreground">{v.title}</p>
                <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{v.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center bg-secondary/50 border border-border rounded-2xl p-10">
          <h2 className="font-serif text-2xl md:text-3xl mb-3">
            Pronta para transformar o teu ritual?
          </h2>
          <p className="text-muted-foreground mb-6 max-w-md mx-auto">
            Descobre a nossa coleção de dispositivos de beleza e começa hoje.
          </p>
          <Link to="/loja">
            <Button className="rounded-full h-12 px-8 text-base">Explorar a loja</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
